import type { JSX } from 'react';

import { SidebarTrigger } from '@/components/ui/sidebar';

const AppHeader = (): JSX.Element => (
  <header className="flex h-14 shrink-0 items-center gap-2 border-b px-3 md:h-12 md:px-4">
    <SidebarTrigger />
  </header>
);

export default AppHeader;
